import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../../../common/CmnContext';
import { PracticeReseveContext } from '../../../../PracticeReseveContext';


function PracticeReserveSelectInstructorModalItem(props: any) {

  const { isPc } = useContext(cmnContext);
  const {
    instId, setInstId, kidPracticeInstIds,
  } = useContext(PracticeReseveContext);

  const inst = props.inst;
  const setIsDispModal = props.setIsDispModal;
  const listWidth = props.listWidth;
  const jaRandomInstructor = props.jaRandomInstructor;
  // 講師情報から画像取得
  const getInstImg = props.getInstImg;
  // 講師情報(日本語可/出身地)
  const getInstInfo = props.getInstInfo;

  const imgSize = isPc? listWidth/7 : listWidth/4;

  const [imgSrc, setImgSrc] = useState<string>('');
  const [instInfo, setInstInfo] = useState<string>('');

  const [isSelected, setIsSelected] = useState<boolean>(false);


  useEffect(() => {
    if(inst) {
      // 画像
      const newImgSrc = getInstImg(inst);
      setImgSrc(newImgSrc);
      // 講師情報: 日本語可/出身地
      const newInstInfo = getInstInfo(inst);
      setInstInfo(newInstInfo);
    }
  }, [inst])


  useEffect(() => {
    setIsSelected(instId == inst.inst_id);
  }, [instId, inst])

  const onClickInst = () => {
    setInstId(inst.inst_id);
    setIsDispModal(false);
  }


  return (
    <div
      key={inst.inst_id}
      style={{
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
        padding: isPc? '15px 2%' : '10px 3%',
      }}
    >

      {imgSrc &&
        <img
          className="img-rounded img-responsive"
          style={{
            width: imgSize,
            height: imgSize,
            objectFit: 'cover',
            marginRight: '10px',
          }}
          src={imgSrc}
        />
      }

      <div style={{flex: 1}}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
          {/* 講師名 */}
          <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>{inst.name}</p>
        </div>

        {inst.inst_id != jaRandomInstructor.inst_id &&
        <>
          {/* 枠数:10件以下の場合に表示 */}
          {inst.schedule_count <= 10 &&
            <p style={{margin: 0, color: 'red', fontSize: '14px', fontWeight: 'bold'}}>残り{inst.schedule_count}枠</p>
          }
          {/* 初心者向け */}
          {inst.is_beginner=='1' &&
            <p className='label label-warning' style={{margin: '0 5px 0 0', fontSize: '11px', fontWeight: 'bold'}}>初心者向け</p>
          }
          {/* キッズプラクティス */}
          {kidPracticeInstIds.includes(inst.inst_id) &&
            <p className='label label-success' style={{margin: 0, fontSize: '11px', fontWeight: 'bold'}}>キッズ対応</p>
          }
          {/* 日本語可/出身地 */}
          {instInfo &&
            <p style={{margin: 0, fontSize: '12px', fontWeight: 'bold'}}>{instInfo}</p>
          }
          {/* 趣味 */}
          {inst.hobby &&
            <p style={{
              margin: 0,
              fontSize: '12px',
              display: '-webkit-box',
              WebkitLineClamp: 2, // 2行まで
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>趣味: {inst.hobby}</p>
          }
        </>
        }

        <button
          type="button"
          className={isSelected? 'btn btn-warning' : 'btn btn-primary'}
          style={{
            alignSelf: 'center',
            width: '100%',
            padding: '5px 10px',
            marginTop: '5px',
          }}
          onClick={onClickInst}
          disabled={isSelected}
        >
          {isSelected? '選択中' : '選択' }
        </button>
      </div>

    </div>
  );
}
  
export default PracticeReserveSelectInstructorModalItem;